<template>
  <div id="disclosure">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>情報開示</b></p>
    <div class="wait-immediate-area">
      <div v-if="isExecuter">
        <p>1人選択し，<br><span v-on:click="showEffect(7)" class="plot-name"><b><u>情報開示</u></b></span>を使用して下さい．</p>
        <div class="assigning-table">
          <v-row class="mx-auto">
            <v-col class="my-n2" v-for="(user, key) in users.filter(user => user.id != userId)" v-bind:key="user.name" >
              <v-card class="" elevation=0 max-width=240 min-width=240>
                <div style="text-align:left;">
                  <v-simple-table dense >
                    <td class="assigning-td" style="width:90px;">
                      <div class="assign-button background-color">
                        <pickButton v-if="isAssigned[key]" v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="true" />
                        <pickButton v-else v-on:pushed="assign(key)" activeLabel="選択" inactiveLabel="未選択" active="false" />
                      </div>
                    </td>
                    <td class="assigning-td" style="padding-left:12px;width:140px">
                      <span class="user-label">{{ user.name }}</span>
                    </td>
                  </v-simple-table>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div class="send-button">
          <sendButton v-if="isAssigned.indexOf(true)>=0" v-on:pushed="push" label="決定" active="true"/>
          <sendButton v-else label="決定" active="false"/>
        </div>
      </div>
      <div v-else>
        <p>{{ executer.name }}の<span v-on:click="showEffect(7)" class="plot-name"><b><u>情報開示</u></b></span>の効果を処理しています。</p>
      </div>
    </div>
    </v-card>
  </div>
</template>

<script>
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "disclosure",
  props: {isExecuter: Boolean, executer: Object},
  components: {
    pickButton,
    sendButton
  },
  data() {
    return {
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      isAssigned: [],
      sent: false
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      return true
      // return this.$store.getters.isLeader;
    },
    plotList () {
      var _plotList = []
      for (var i in this.users){
        for (var j in this.users[i].plots) {
          _plotList.push({'isAssigned': false, 'plotId': this.users[i].plots[j], 'plotName': this.$store.getters.getPlotEffect(this.users[i].plots[j]), 'userId': this.users[i], 'userName': this.users[i].name})
        }
      }
      return _plotList
    },
    haveDisclosure () {
      var haveDisclosure = this.users.find(user => user.id == this.userId).plots.filter(plot => plot.id == 7 && !plot.done)
      if (haveDisclosure.length>0){
        return true
      }
      return false
    }
  },
  methods: {
    assign(num) {
      if (this.isAssigned[num]){
        this.$set(this.isAssigned, num, false)
      }else {
        for (var i=0; i<this.users.length; i++){
          this.$set(this.isAssigned, i, false)
        }

        this.$set(this.isAssigned, num, true)
        // this.isAssigned[num] = true
        // this.previousSelect = num
      }
    },
    showEffect: function(id){
      this.$emit('send-effect', id)
    },
    push: function() {
      console.log("execute-action")
      // this.sent = true
      this.$emit("execute-action", {"action": "execute-disclosure", "roomId": this.roomId, "userId": this.userId, data: {"disclosure": this.users.filter(user => user.id != this.userId)[this.isAssigned.indexOf(true)].id}})
    }
  },
  created() {
    for (var i=0; i<this.users.filter(user => user.id != this.userId).length; i++){
      this.isAssigned.push(false)
    }
  }
};
</script>

<style>
#waitImmediateEffect {
  /* background-color: rgb(253, 208, 208); */
}
#waitImmediateEffect .send-button{
  padding-top: 16px;
  padding-bottom: 16px;
  /* display: inline-block; */
}
#waitImmediateEffect .assigning-table {
 align-items: left;
 display: inline-block;
 text-align:center;
}
#waitImmediateEffect td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#waitImmediateEffect .background-color {
  background-color: #F6F6FA;
}
#waitImmediateEffect .assign-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}
#waitImmediateEffect .invalid-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #F6F6FA
}
#waitImmediateEffect .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
